import {
  CodeConfigurationField,
  LandingPageDestination
} from '@dtx-company/inter-app/src/types/flowcode'
import { FC, useRef } from 'react'
import { ScanDestinationFieldProps } from '../ScanDestination'
import { TextField } from '@dtx-company/design-system/src'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import {
  selectError,
  selectNormalizedScanDestination
} from '@dtx-company/app/shared/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@dtx-company/app/shared/common/src/hooks/useGlobalServices'
import { useOnChange } from '../hooks/useOnChange'
import { useOnErrorScrollInToView } from '../hooks/useOnErrorScrollInToView'
import { useScanDestinationOptions } from '../hooks/useScanDestinationOptions'
import { useSelector } from '@xstate/react'
import useTranslation from 'next-translate/useTranslation'

export const InstagramField: FC<ScanDestinationFieldProps> = ({ size = 'large' }) => {
  const { t } = useTranslation('logged-out-generator')
  const scanDestinationOptions = useScanDestinationOptions()
  const { locgService } = useGlobalServices()
  const normalizedScanDestination = useSelector(locgService, selectNormalizedScanDestination)
  const { Icon } = scanDestinationOptions[LandingPageDestination.INSTAGRAM]
  const error = useSelector(locgService, selectError)(CodeConfigurationField.SCAN_DESTINATION)
  const ref = useRef<HTMLInputElement>(null)
  useOnErrorScrollInToView(Boolean(error), ref)

  const onChange = useOnChange()

  return (
    <TextField
      size={size}
      name={CodeConfigurationField.SCAN_DESTINATION}
      label={t('LoggedOutGenerator.ScanDestination.options.instagram.label')}
      hiddenLabel
      value={normalizedScanDestination}
      placeholder={t(
        'LoggedOutGenerator.ScanDestination.options.instagram.subcomponents.InstagramInput.placeholder'
      )}
      startAdornment={<Icon sx={{ color: 'onSurface.secondary' }} />}
      onChange={onChange}
      onFocus={() => fireAnalyticsEvent('LoggedOutGenerator_ScanDestinationInputInstagram_Focused')}
      onBlur={e => {
        fireAnalyticsEvent('LoggedOutGenerator_ScanDestinationInputInstagram_Blurred', {
          text: e.target.value
        })
      }}
      inputProps={{
        'data-heap-id': 'LoggedOutGenerator_ScanDestinationInputInstagram',
        ref
      }}
      error={!!error}
      helperText={error}
    />
  )
}
